module.exports = __webpack_public_path__ + "static/yolcu-360-digital-marketing-29f20a33765773b6805f5e362d96b5a2.png";